import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const doctorFinancialRecordsRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.doctorFinancialRecords.route,
      lazy: () =>
        import(
          "@pages/panelPages/financialManagements/financialRecords/doctorFinancialRecords"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.financialManagements.financialRecords",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["doctor"],
  },
];
